// components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRouteHome = ({ children }) => {
  const { authenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="login-card"><h1>Loading...</h1></div>; // show splash instead of Login
  }

  if (!authenticated) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/Login" replace />;
  }

  return children;
};

export default ProtectedRouteHome;
